/**
 * Scroll reveal for product cards (pairs with .luxe-reveal in luxe.css).
 * The hidden state only exists once this script adds the class, so cards
 * are always visible without JS, in the theme editor, and under
 * prefers-reduced-motion. Classes are removed after the reveal finishes
 * so the theme's own hover transitions apply again.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  const STAGGER_STEP_MS = 70;
  const STAGGER_COLUMNS = 4;
  const REVEAL_DURATION_MS = 750;

  const reveal = (card) => {
    card.classList.add('luxe-in');
    const delay = parseInt(card.style.getPropertyValue('--luxe-stagger'), 10) || 0;
    setTimeout(() => {
      card.classList.remove('luxe-reveal', 'luxe-in');
      card.style.removeProperty('--luxe-stagger');
    }, REVEAL_DURATION_MS + delay);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        reveal(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  document.querySelectorAll('.product-card').forEach((card, index) => {
    card.classList.add('luxe-reveal');
    card.style.setProperty('--luxe-stagger', `${(index % STAGGER_COLUMNS) * STAGGER_STEP_MS}ms`);
    observer.observe(card);
  });
})();
